// extracted by css-extract-rspack-plugin
export default {"calculator-container":"xnCmNMJ___calculator-container","calculatorContainer":"xnCmNMJ___calculator-container"};